
// COMPONENTS
import process_schedule from './schedule.js';
import bgworker_status_bar from './bgworker-status-bar.js';

export default [
	process_schedule,
	bgworker_status_bar
];
